import config from 'Lib/config'
import AlsoSlug from 'Components/Also/Slug'
import AluxoSlug from './Slug'

const Slug = config.reseller.also ? AlsoSlug : AluxoSlug

export default Slug
